
import Vue from 'vue'
import { mapGetters, mapActions, mapState } from 'vuex'

interface Container {
  id: string,
  x: number,
  y: number,
  width: number,
  height: number,
  fill: string,
  stroke: string,
  strokeWidth: number,
  type: string
}

export default Vue.extend({
  props: {
    data: {
      type: Array   
    }   
  },
  data() {
    return {    
    }
  },
  components: {    

  },
  methods: {
    ...mapActions({
      setSelectedHatchData: 'setSelectedHatchData'
    }),
    initCells() {
      // Generate grid cells  
      var cellsCount = this.cellsCount;
      let id = 0;
      for (let row = 0; row < this.rows; row++) {
        for (let col = 0; col < cellsCount; col++) {
          this.cells.push({
            id: id++,
            x: col * this.cellSize + 0.6,
            y: row * this.cellSize,
            width: this.cellSize,
            height: this.cellSize,
            fill: "white",
            stroke: "gray",
            strokeWidth: 1,
          });
        }
      }
      //this.updateCells()
    }   
  },
  computed: {

    Cells() {
      const updatedCells = [...this.cells]; 

      updatedCells.forEach((cell) => {
        cell.id = this.toStringId(cell.id);  
        cell.fill = "white"; 
      });

      this.vesselProfileHatchCovers?.map(data => {
        updatedCells.forEach((cell) => {
          if (cell.id >= data.startCell && cell.id <= data.endCell) {
            cell.fill = this.CoverColor; // رنگ‌بندی سلول‌های انتخابی
          }
          if (cell.id == data.endCell + 1 || cell.id == data.startCell - 1) {
            cell.isGap = true;
          }
        });
      });

      return updatedCells;
    },

    ...mapState(['vesselProfile']),
    configKonvaCovers() {
      return {
        width: this.data?.cols * this.cellSize + 1,
        height: this.cellsCount + 10
      }
    }
  },
  created() {    
    this.initCells()
  }
})
